<template>
    <div>
        <!-- Окно для создания инструкции -->
        <vs-popup
            class="create_instr_dialog instr_dialog"
            :title="$t('create_update_instruction')"
            :active.sync="modalActive">
                <form class="w-full h-screen instr_form">

                    <div class="vx-row mb-4 relative z-top">
                        <!-- Страница -->
                        <vs-col vs-w="12" class="px-4 mb-1">
                            <label class="vs-input--label">{{$t('page')}}</label>
                            <multiselect
                                style="width: 100%;"
                                :value="page"
                                :options="routes"
                                :placeholder="$t('page')"
                                class="page_width"
                                :custom-label="pageSelectLabel"
                                @select="pageSelect"
                                deselectLabel=""
                                selectLabel="">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="flex">
                                            {{$t(props.option.name)}}
                                            <vs-chip color="primary">
                                                {{ props.option.path }}
                                            </vs-chip>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="flex">
                                            {{$t(props.option.name)}}
                                            <vs-chip color="primary">
                                                {{ props.option.path }}
                                            </vs-chip>
                                        </div>
                                    </template>
                                    <div slot="noOptions">{{ $t("no_data_text") }}</div>
                            </multiselect>
                        </vs-col>

                        <!-- Роль -->
                        <vs-col vs-w="12" class="px-4 mb-1">
                            <label class="vs-input--label">{{$t('role')}}</label>
                            <multiselect
                                style="width: 100%;"
                                label="name"
                                v-model="instructional.role_related"
                                :options="roleList"
                                selectedLabel=""
                                :placeholder="$t('role')"
                                :loading="roleLoading"
                                @open="openSelect()"
                                @select="filterSelect"
                                deselectLabel=""
                                selectLabel=""
                                track-by="uid">
                                    <div slot="noOptions">{{ $t("no_data_text") }}</div>
                            </multiselect>
                        </vs-col>
                        <!-- Язык -->
<!--                        <vs-col vs-w="12" class="px-4 mb-1">-->
<!--                            <label class="vs-input&#45;&#45;label">{{$t('language')}}</label>-->
<!--                            <multiselect-->
<!--                                :disabled="!instructional.role_related"-->
<!--                                label="text"-->
<!--                                v-model="instructional.language"-->
<!--                                :options="languageList"-->
<!--                                @select="filterSelect"-->
<!--                                name="language"-->
<!--                                selectedLabel=""-->
<!--                                :placeholder="$t('language')"-->
<!--                                class="w-full"-->
<!--                                v-validate="'required'"-->
<!--                                deselectLabel=""-->
<!--                                selectLabel=""-->
<!--                                track-by="value">-->
<!--                                    <div slot="noOptions">{{ $t("no_data_text") }}</div>-->
<!--                            </multiselect>-->
<!--                            <span class="text-danger text-sm" v-show="errors.has('language')">{{ $t('validation_required') }}</span>-->
<!--                        </vs-col>-->
                    </div>

                    <template v-if="formShow">
                        <div v-if="showList">
                            <ul>
                                <li
                                    v-for="(instruction, index) in instructions"
                                    :key="index"
                                    class="list_items"
                                    @click="toggleShowEdit(instruction)"    >
                                    <div class="truncate">{{ instruction.name }}</div>
                                </li>
                            </ul>
                        </div>

                        <!-- Название инструкции -->
                        <div v-if="showEdit">
                            <vs-button @click="toggleShowEdit(null)" class="mb-4" size="small">{{ $t("return_back") }}</vs-button>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input name="name" class="w-full" v-validate="'required'" :placeholder="$t('manual_name')" v-model="instructional.name" />
                                <span class="text-danger text-sm" v-show="errors.has('name')">{{ $t('validation_required') }}</span>
                            </div>
                        </div>

                        <!-- Текстовая область -->
                        <div class="vx-row mb-6">
                            <div class="vx-col">
                                <quill-editor
                                    ref="instrEditor"
                                    :options="editorOption"
                                    class="w-full"
                                    v-validate="'required'"
                                    name="text"
                                    v-model="instructional.text" />
                                <span class="text-danger text-sm" v-show="errors.has('text')">{{ $t('validation_required') }}</span>
                            </div>
                        </div>

                        <!-- Загрузка файлов -->
                        <div class="vx-row mb-6 z-0">
                            <div class="vx-col">
                                <label class="vs-input--label">{{$t('select_a_file')}}</label>
                                <vs-upload :action="'common/upload/'"
                                    @on-success="setFiles"
                                    @prev-delete="removeFile"
                                    ref="imageUpload"

                                    :firstFiles="files"

                                    automatic
                                    :max-size="10"
                                    :fileName="'path'" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col button_col">
                                <vs-button @click.prevent="buttonHandler" :color="buttomColor" type="filled">{{sendText}}</vs-button>
                                <!--<vs-button @click.prevent="deleteHandler" v-if="update" color="danger" type="filled">{{$t('remove')}}</vs-button>-->
                            </div>
                        </div>
                        </div>
                    </template>
                </form>
        </vs-popup>

        <!-- Окно загрузки файлов в текстовый редактор -->
        <vs-popup class="upload_popup" :button-close-hidden="uploadPopupButton" :title="uploadPopupTitle" :active.sync="filesPopup">
            <vs-row>
                <vs-col vs-offset="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <label for="files_instr" class="files_input_button vs-component vs-button vs-button-primary vs-button-filled includeIcon">
                        <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-upload null" style="order: 0; margin-right: 5px; margin-left: 0px;"></i>
                        <span class="vs-button-text vs-button--text">{{$t('select_file')}}</span>
                    </label>
                    <input type="file" id="files_instr" class="files_input" :accept="this.accept" multiple ref="files_instr" v-on:change="handleFileQuillUpload()"/>
                </vs-col>
            </vs-row>
        </vs-popup>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { Quill, quillEditor } from 'vue-quill-editor'
import { HtmlEditor, DocumentBlot, AudioBlot } from './QuiilSetting'

import { mapActions } from "vuex";
import { Validator } from "vee-validate";

import routes from '@/pages/Home/routers'
import VuePerfectScrollbar from "vue-perfect-scrollbar";

Quill.register(AudioBlot);
Quill.register(DocumentBlot);
Quill.register('modules/htmlEditor', HtmlEditor);

const messages = {
    custom: {
        name: {
            required: "Это обязательное поле"
        }
    },
};

Validator.localize("en", messages);

export default {
    data() {
        return {
            instructions: [],
            showEdit: false,
            showList: true,
            files: [],
            firstFiles: [],
            sendText: this.$t('send'),
            buttomColor: 'primary',
            filesPopup: false,
            uploadPopupTitle: '',
            uploadPopupButton: false,
            uploadType: null,
            formShow: false,
            accept: null,
            update: false,
            routes: routes,
            page: null,
            instructional: {
                language: null,
                name: '',
                text: '',
                code: '',
                role_related: null
            },
            buttonHandler: () => this.submitHandler(),
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ['link', 'code-block'],
                            ['clean'],
                            ['image_upload'],
                            ['video_upload'],
                            ['audio_upload'],
                            ['dov_upload'],
                            ['video']
                        ],
                        handlers: {
                            image_upload: () => {
                                this.filesModalHandler('image')
                            },
                            video_upload: () => {
                                this.filesModalHandler('video')
                            },
                            audio_upload: () => {
                                this.filesModalHandler('audio')
                            },
                            dov_upload: () => {
                                this.filesModalHandler('doc')
                            },
                        }
                    }
                },
                placeholder: this.$t('enter_text')
            },
            roleLoading: false,
            languageList: [
                // { text: this.$t('kazak'), value: 'kk' },
                { text: this.$t('english'), value: 'en' },
                // { text: this.$t('russian'), value: 'ru' }
            ]
        }
    },
    created: function() {
        this.instructional.language = { text: this.$t('english'), value: 'en' }

        this.routes = this.routes.filter((item) => {
            return item.hide !== true
        })

        // delete some page
        this.routes.splice(7, 1)
        this.routes.splice(13, 1)
        let found = this.routes.filter((r) => r.name === 'log_in')
        if (found.length === 0){
            this.routes.push( { name: 'log_in' } )
        }
        const route = this.routes.find(item => item.name === this.$route.name)

        if(route)
            this.page = route
    },
    components: {
        quillEditor
    },
    methods: {
        ...mapActions({
            deleteInstructional: "instructional/deleteInstructional",
            putInstructional: "instructional/putInstructional",
            postInstructional: "instructional/postInstructional",
            getRole: "instructional/getRole"
        }),
        toggleShowEdit(instruction){
            if(instruction){
                this.generateForm(instruction)
            }
            this.showEdit = !this.showEdit
            this.showList = !this.showList
        },
        pageSelect(item) {
            this.page = item
            if(this.instructional.role_related && this.instructional.language)
                this.filterSelect({uid: null, value: null})
        },
        pageSelectLabel(item) {
            return this.$t(item.name) + "; path " + item.path
        },
        clearForm() {
            // Полностью очищаем форму, возвращаем текста, хэндлеры к начальному состаянию, очищаем валидацию
            this.instructional.code = ''
            this.instructional.text = ''
            this.instructional.name = ''
            //this.instructional.language = this.languageList.find(lang => lang.value === this.$route.params.lang)

            this.files = []

            this.buttomColor = 'primary'
            this.update = false
            this.sendText = this.$t('send')
            this.buttonHandler = () => this.submitHandler()

            this.$validator.reset()
        },
        setFileDataForPreview(data){
            // В vs-upload свои особенности. Ждет у объекта response
            const new_data = {
                ...data,
                response: data,
            };
            return new_data
        },
        generateForm(instr = null) {
            // если существует инструкция, генерируем данные для формы, меняем текста, функции хэндлеров
            if(instr) {
                this.buttomColor = 'success'

                this.files = []

                this.instructional = {
                    language: this.languageList.find(item => item.value === instr.language),
                    name: instr.name,
                    text: instr.text,
                    code: instr.code,
                    role_related: instr.role_related,
                    id: instr.id
                }

                // Подставляем роль с сервера либо подстовляем опцию все роли
                if(instr.role_related) {
                    if(instr.role_related.name)
                        this.instructional.role_related = instr.role_related
                    else
                        this.instructional.role_related = {
                            name: this.$t('all_role'),
                            uid: "all"
                        }
                }

                if(instr.files.length) {
                    let new_file_data = []
                    instr.files.forEach((file)=> {
                        let corrected =  this.setFileDataForPreview(file)
                        new_file_data.push(corrected)
                    })
                    this.files = new_file_data
                    // При загрузке новых файлов список в this.files будет содержать только новые файлы,
                    // поэтому делаем из бекап в другой переменной
                    this.firstFiles = new_file_data

                }

                this.update = true
                this.sendText = this.$t('update')
                this.buttonHandler = () => this.updateHandler()
            }
        },
        async filterSelect(option) {
            // Прежде чем запросить инструкцию, заполняем обязательные поля роль и язык, и после этого делаем запрос
            const role = option.uid ? option : this.instructional.role_related
            const lang = option.value ? option : this.instructional.language

            if(role && lang) {
                try {
                    this.$vs.loading({
                        container: '.instr_form',
                        scale: 0.6
                    })
                    this.formShow = false

                    let queryData = {
                        code: this.page.name
                    }

                    queryData['lang'] = lang.value

                    if(role.uid !== 'all')
                        queryData['role'] = role.uid

                    // когда сервер выдавал {error: "instruction_not_found"},
                    // предыдущие данные были на экране, что может вводить в заблуждение
                    // поэтому лучше почистить
                    this.instructions = []
                    this.showEdit = false
                    this.showList = true

                    const {data} = await this.$http.get("/instruction/get/", {
                        params: queryData
                    })
                    this.instructions = data
                    // Если инструкция есть вставляем данные в форму
                    // this.generateForm(data[0])
                } catch(e) {
                    // Если инструкции нету, очищаем форму
                    this.clearForm()
                    this.showEdit = true
                } finally {
                    this.formShow = true
                    this.$vs.loading.close('.instr_form > .con-vs-loading')
                }
            } else {
                // Если обязательные поля не заполнены, не показываем инструкцию
                this.formShow = false
            }
        },
        async removeFile({ file, done }){
            this.files = await this.files.filter( (item) => item.response.uid !== file.response.uid );
            this.firstFiles = await this.firstFiles.filter( (item) => item.response.uid !== file.response.uid );
            done();
        },
        setFiles(response){
            if (!this.files) this.files = [];
            let new_file_data = []
            response.forEach((file)=> {
                let corrected =  this.setFileDataForPreview(file)
                new_file_data.push(corrected)
            })
            this.files = new_file_data
        },
        async openSelect() {
            // Получаем список ролей для выбора
            try {
                this.roleLoading = true
                await this.getRole(this.$t('all_role'))
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.roleLoading = false
            }
        },
        filesModalHandler(type) {
            // Quill
            // Подставляем нужные настройки при выборе типа загрузки файла
            switch(type) {
            case 'image':
                this.uploadPopupTitle = this.$t('upload_image')
                this.uploadType = 'image'
                this.accept = ".jpg, .jpeg, .png, .gif"
                break;
            case 'video':
                this.uploadPopupTitle = this.$t('upload_video')
                this.uploadType = 'video'
                this.accept = "video/*"
                break;
            case 'audio':
                this.uploadPopupTitle = this.$t('upload_audio')
                this.uploadType = 'audio'
                this.accept = "audio/*"
                break;
            case 'doc':
                this.uploadPopupTitle = this.$t('upload_document')
                this.uploadType = 'doc'
                this.accept = ".doc, .docx, .xlsx, .xls, .pdf"
                break;
            }
            this.filesPopup = true
        },
        async handleFileQuillUpload() {
            // Получаем файлы от поля загрузки
            const files = this.$refs.files_instr.files;

            // Проверяем выбранное количество файлов для загрузки, если больше 5 то отменяем загрузку и выводм сообщение
            if(files.length > 5) {
                this.$vs.notify({
                    text: this.$t('file_max', { max: 5 }),
                    color: 'warning'
                })
            }

            // Заполняем formData перед загрузкой файлов
            let formData = new FormData();
            for( var i = 0; i < files.length; i++ ){
                // Проверяем размер файла, если превышает выводим сообщение
                let maxFileSize = 10

                // Если это видео, ставим макс размер файла на 100 мб
                if(this.uploadType === 'video') maxFileSize = 100

                // Если это аудио, ставим макс размер файла на 50 мб
                if(this.uploadType === 'audio') maxFileSize = 50

                if (10 && ((files[i].size / 1024) / 1024) >= maxFileSize ){
                    this.$vs.notify({
                        text: this.$t('file_size_error', { name: files[i].name, filesize: maxFileSize }),
                        color: 'warning'
                    })
                    continue;
                }
                if(i > 4)
                    continue;
                formData.append('path', files[i]);
            }

            // Если formData не пустая то продолжаем отправку
            if(formData.has('path')) {
                try {
                    this.$vs.loading({
                        background: 'primary',
                        color: '#fff',
                        container: '.files_input_button',
                        scale: 0.45
                    })
                    this.uploadPopupButton = true

                    // Загружаем файлы на сервер
                    const {data} = await this.$http.post('common/upload/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                    // Фокусируемся на quill для вставки файла
                    this.editor.focus()
                    let length = this.editor.getSelection().index;

                    // В цикле вставляем файлы в поле quill
                    data.forEach(file => {
                        if(this.uploadType === 'doc') this.editor.insertEmbed(length, this.uploadType, file)
                        else this.editor.insertEmbed(length, this.uploadType, file.path)
                    })

                    this.filesPopup = false
                    this.$vs.notify({ text: this.$t('file_add'), color:'success' })
                } catch(error) {
                    this.$vs.notify({ text: error, color:'danger' })
                } finally {
                    this.$vs.loading.close('.files_input_button > .con-vs-loading')
                    this.uploadPopupButton = false
                }
            }
        },
        collectFileUids(){
            let file_uids = []
            this.files.forEach((file)=>{
                if (!file_uids.includes(file.uid)){
                    file_uids.push(file.uid)
                }
            })
            this.firstFiles.forEach((file)=>{
                if (!file_uids.includes(file.uid)){
                    file_uids.push(file.uid)
                }
            })
            return file_uids
        },
        async updateHandler() {
            // Если валидация прошла, начинаем обновление инструкции
            this.$validator.validateAll().then(async result => {
                if (result) {
                    try {
                        this.$vs.loading();
                        let file_uids = this.collectFileUids()
                        // Отправляем обновленную инструкцию на сервер
                        await this.putInstructional({
                            language: this.instructional.language.value,
                            name: this.instructional.name,
                            text: this.instructional.text,
                            files: file_uids,
                            code: this.page.name,
                            id: this.instructional.id,
                            role_related: this.instructional.role_related
                        })

                        // Показываем сообщение что все ок и закрываем окно
                        this.$vs.notify({ text: this.$t('manual_updated'), color:'success' })
                        this.modalActive = false
                    } catch (e) {
                        // Выводим ошибку
                        this.$vs.notify({ text: this.$t('error'), color:'danger' })
                    } finally {
                        this.$vs.loading.close()
                    }
                }
            })
        },
        async deleteHandler() {
            // Удаляем инструкцию
            this.$vs.loading();
            await this.deleteInstructional(this.$route.name)
            this.$vs.notify({ text: this.$t('instruction_removed'), color:'success' })
            this.modalActive = false
            this.$vs.loading.close()
        },
        submitHandler() {
            // Если валидация прошла, начинаем сохранение инструкции
            this.$validator.validateAll().then(async result => {
                if (result) {
                    try {
                        this.$vs.loading()
                        let file_uids = this.collectFileUids()
                        // Отправляем инструкцию на сервер
                        await this.postInstructional({
                            language: this.instructional.language.value,
                            name: this.instructional.name,
                            text: this.instructional.text,
                            files: file_uids,
                            code: this.page.name,
                            role_related: this.instructional.role_related
                        })

                        // Показываем сообщение что все ок и закрываем окно
                        this.$vs.notify({ text: this.$t('instruction_saved'), color:'success' })
                        this.modalActive = false
                    } catch (error) {
                        let e = error

                        if(error.non_field_errors)
                            e = this.$t('non_field_errors')

                        // Выводим ошибку
                        this.$vs.notify({ text: e, color:'danger' })
                    } finally {
                        this.$vs.loading.close()
                    }
                }
            })
        }
    },
    computed: {
        modalActive: {
            // Чекаем открытие/закрытие модалки
            get () {
                return this.$store.getters['modal/getModalByKey']('AddInscructional')
            },
            set () {
                this.$store.commit('modal/SET_STATE', 'AddInscructional')
            }
        },
        roleSelected: {
            get () {
                return this.$store.state.instructional.roleSelected
            },
            set (val) {
                this.$store.commit('instructional/SET_SELECTED_ROLE', val)
            }
        },
        roleList() {
            return this.$store.state.instructional.roleList
        },
        editor () {
            return this.$refs.instrEditor.quill
        },
        instructionalStore() {
            if(this.$store.state.instructional.instructional)
                return this.$store.state.instructional.instructional[`${ this.$route.name }_${ this.$route.params.lang }`]
            else
                return null
        }
    }
}
</script>

<style lang="scss">
//.vs-popup--content{
//    /* Когда было много контента, кнопка обновить уходила за пределы видимости*/
//    max-height:  calc(90vh);
//}
.list_items{
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 8px;
    border-radius: 5px;
    margin-bottom: 0.5em;
}
.list_items:hover {
    background-color: bisque;
    cursor: pointer;
}
.create_instr_dialog{
    .vs-popup{
        min-height: calc(100% - 30px);
    }
    .page_width{
        width: 300px;
    }
    .ql-toolbar{
        position: sticky;
        top: -15px;
        z-index: 100;
        background: #fff;
    }
}
.ql-image_upload2,
.ql-dov_upload2,
.ql-image_upload,
.ql-video_upload,
.ql-audio_upload,
.ql-dov_upload{
    font-size: 18px;
    font-family: feather;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.ql-image_upload2,
.ql-image_upload{
    &::before{
        content: "\e87c";
    }
}
.ql-video_upload{
    &::before{
        content: "\e8ec";
    }
}
.ql-audio_upload{
    &::before{
        content: "\e89d";
    }
}
.ql-dov_upload2,
.ql-dov_upload{
    &::before{
        content: "\e870";
    }
}
.upload_popup{
    z-index: 54000;
    .files_input{
        display: none;
    }
    .vs-popup{
        width: 400px!important;
    }
    .files_input_button{
        position: relative;
        overflow: hidden;
        .con-vs-loading{
            position: absolute;
        }
    }
}
</style>

<style scoped lang="scss">
.z-top{
    z-index: 999;
}
.instr_form{
    min-height: 200px;
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.create_instr_dialog{
    .button_col{
        button:not(:last-child){
            margin-right: 15px;
        }
    }
}
</style>
